export const userActivityLog = {
  userActivityLogs: "User Activity Logs",
  from: "From",
  to: "To",
  advanceFilter: "Advance Filter",
  status: "Status",
  selectStatus: "SELECT STATUS",
  all: "ALL",
  pending: "PENDING",
  approved: "APPROVED",
  rejected: "REJECTED",
  userId: "User ID",
  username: "Username",
  action: "Action",
  updatedField: "Updated Field",
  originalValue: "Original Value",
  updatedValue: "Updated Value",
  notes: "Notes",
  cancel: "Cancel",
  filter: "Filter",
  updatedBy: "UPDATED BY",
  approvedBy: "APPROVED BY",
  updatedDate: "UPDATED DATE",
  status: "STATUS",
  amount: "AMOUNT",
  createdAt: "CREATED DATE",
  traceId: "TRACE ID",
};
